/* Conneqt.Point — Produktseite (Standard/InkCase/MagSafe)
   Dropdown-Varianten, dynamischer Bildwechsel, InkCase-Bundle (1/2 Stück), korrekte Mathematik. */
(function () {
  'use strict';
  var root = document.getElementById('product-form');
  var data = window.CQ_SIMPLE;
  if (!root || !data) return;

  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + ' \u20AC'; };

  var opts = Array.prototype.slice.call(root.querySelectorAll('.cq-opt'));
  var idSel = root.querySelector('[data-variant-select]');
  var priceTop = document.querySelector('.pdp-price');
  var carousel = document.querySelector('[data-carousel]');
  var addBtn = root.querySelector('[data-add-btn]');

  function chosenOptions() { return opts.map(function (s) { return s.value; }); }

  function findVariant() {
    var chosen = chosenOptions();
    var exact = data.variants.filter(function (v) {
      return v.opts.length === chosen.length && v.opts.every(function (o, i) { return o === chosen[i]; });
    })[0];
    if (exact) return exact;
    // Fallback: match first option (e.g. model) if exact combo missing
    var partial = data.variants.filter(function (v) { return v.opts[0] === chosen[0]; })[0];
    return partial || data.variants[0];
  }

  function currentQty() {
    var r = root.querySelector('input[name="icqty"]:checked');
    return r ? parseInt(r.value, 10) : 1;
  }

  function swapImage(v) {
    if (!carousel || !v || !v.imgid) return;
    var slides = carousel.querySelectorAll('.pdp-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('data-img-id') === String(v.imgid)) {
        carousel.scrollTo({ left: i * carousel.clientWidth, behavior: 'smooth' });
        var wrap = carousel.closest('[data-gallery]') || carousel.parentNode;
        wrap.querySelectorAll('[data-dot]').forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        wrap.querySelectorAll('[data-thumb-index]').forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.thumbIndex, 10) === i); });
        break;
      }
    }
  }

  function render() {
    var v = findVariant();
    if (v && idSel) { idSel.value = v.id; }

    if (v && priceTop) {
      var amt = priceTop.querySelector('.amount');
      if (amt) amt.textContent = money(v.price);
      var cmp = priceTop.querySelector('.compare');
      if (cmp) {
        if (v.cmp && v.cmp > v.price) { cmp.textContent = money(v.cmp); cmp.style.display = ''; }
        else { cmp.style.display = 'none'; }
      }
    }

    if (data.isInkcase && v) {
      var p1 = root.querySelector('[data-ic-p1]');
      if (p1) p1.innerHTML = (v.cmp && v.cmp > v.price ? '<s>' + money(v.cmp) + '</s> ' : '') + money(v.price);
      var p2 = root.querySelector('[data-ic-p2]');
      var duoTotal = v.price * 2 - data.bundleDiscount;
      if (p2) p2.textContent = money(duoTotal);
      var tot = root.querySelector('[data-ic-total]');
      if (tot) tot.textContent = currentQty() === 2 ? money(duoTotal) : money(v.price);
      root.querySelectorAll('.ic-bundle .ubox').forEach(function (b) {
        var r = b.querySelector('input[name="icqty"]');
        b.classList.toggle('is-active', r && r.checked);
      });
    }
  }

  root.addEventListener('change', function (e) {
    render();
    if (e.target.classList.contains('cq-opt')) swapImage(findVariant());
  });

  render();
  swapImage(findVariant());

  if (addBtn) {
    addBtn.addEventListener('click', function (e) {
      var v = findVariant();
      if (!v) return;
      // InkCase Partner-Set (2 Stück): 2x hinzufügen + 10-€-Rabattcode an der Kasse
      if (data.isInkcase && currentQty() === 2) {
        e.preventDefault();
        addBtn.disabled = true;
        addBtn.textContent = 'Wird hinzugefügt …';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 2 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function () { window.location.href = '/checkout?discount=' + encodeURIComponent(data.duoCode); })
          .catch(function () { addBtn.disabled = false; addBtn.innerHTML = 'In den Warenkorb'; alert('Bitte erneut versuchen.'); });
      }
      // 1 Stück / andere Produkte: normales Formular fügt genau 1x der gewählten Variante hinzu
    });
  }
})();
